export default "__VITE_ASSET__7ZpWtq1x__"